export default __webpack_public_path__ + "static/media/starYellowBorder.1d71f11a.svg";